import React, { FC } from 'react';

import * as S from './styles';
import { Subscription } from '../../services/firebaseInit';
import { CustomerPortalButton } from 'src/components/CustomerPortalButton';

const links = {
  QA: 'https://marketplace.visualstudio.com/items?itemName=appgami.appgami-retrospectives&ssr=false#qna',
  docs: 'https://appgami.atlassian.net/wiki/spaces/AzureDevOps/pages/356548613/Appgami+Retrospectives',
  eula: 'https://www.appgami.com/terms-of-service',
  privacyPolicy: 'https://www.appgami.com/privacy-policy',
};

type AdminPageProperties = {
  subscription: Subscription;
};

export const AdminPage: FC<AdminPageProperties> = ({ subscription }) => {
  function getSubscriptionStatus(subscription: Subscription) {
    if (subscription.type === 'trial') {
      return subscription.isActive ? 'Trial' : 'Trial expired';
    }
    return subscription.isActive ? 'Active' : 'Expired';
  }

  return (
    <S.Container>
      <S.SubContainer>
        <h1>Appgami Retrospectives</h1>
        <p>
          Please visit out <a href={links.QA}>Q&A page</a> for support or drop
          us a line at{' '}
          <a href="mailto:support@appgami.com">support@appgami.com</a>. For more
          information, please check out
          <a href={links.docs}> documentation</a>,<a href={links.eula}> EULA</a>{' '}
          or
          <a href={links.privacyPolicy}> Privacy Policy</a>.
        </p>

        <S.PlanDetailsContainer>
          <h2>
            Plan details
            <S.Lozenge isActive={subscription.isActive}>
              {getSubscriptionStatus(subscription)}
            </S.Lozenge>
            <a href="https://stripe.com" target="top">
              <S.StripeBadge
                src={process.env.PUBLIC_URL + '/img/stripe-badge.svg'}
                alt="Powered by Stripe"
              />
            </a>
          </h2>
          {subscription.type === 'trial' && (
            <>
              <S.PlanDetailsRow>
                <div>
                  <h3>Your Plan</h3>
                  Free 7-day trial
                </div>
                <div>
                  <h3>Trial Period</h3>
                  {new Date(subscription.startsAt!).toLocaleDateString()} -{' '}
                  {new Date(subscription.endsAt!).toLocaleDateString()}
                </div>
              </S.PlanDetailsRow>

              <h2>Subscription</h2>
              {subscription.isActive ? (
                <p>
                  If you'd like to authorize automatic billing at the end of the
                  trial, please click 'Subscribe' and provide your billing
                  details in advance.
                </p>
              ) : (
                <p>
                  Your trial has expired. Please, purchase an annual
                  subscription to continue using Appgami Retrospectives.
                </p>
              )}
              <CustomerPortalButton>Subscribe</CustomerPortalButton>
            </>
          )}

          {subscription.type === 'paid' && (
            <>
              <S.PlanDetailsRow>
                <div>
                  <h3>Your Plan</h3>
                  Standard ($575/year + tax)
                </div>
                <div>
                  <h3>Billing Period</h3>
                  {new Date(subscription.startsAt!).toLocaleDateString()} -{' '}
                  {new Date(subscription.endsAt!).toLocaleDateString()}
                </div>
                <div>
                  <h3>Next Invoice</h3>
                  {subscription.nextInvoice
                    ? new Date(subscription.nextInvoice).toLocaleDateString()
                    : 'No further invoices will be issued.'}
                </div>
              </S.PlanDetailsRow>

              <h2>Billing Actions</h2>
              <p>
                Manage payment method, billing information, view invoices or
                cancel your subscription on our customer portal.
              </p>
              <CustomerPortalButton>Customer portal</CustomerPortalButton>
            </>
          )}
        </S.PlanDetailsContainer>
      </S.SubContainer>
    </S.Container>
  );
};
